import axios from 'axios';
import { storeMutation } from '../storeMutations.constant';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { getBasicHeaders } from '../../common/utils/utils';
import {wrapAction} from '../../common/utils/actionLifecycle';


const notificationState = () => ({
    baseURL: process.env.VUE_APP_BASE_URL,
    fcmToken: null,
    unReadNotificationCount: 0,
    systemMessages: null,
});

const notificationMutations = {
    [storeMutation.setfcmToken]: (state, data) => {
        state.fcmToken = data;
    },
    [storeMutation.setUnReadNotificationCount]: (state, data) => {
        state.unReadNotificationCount = data;
    },
    [storeMutation.setSystemMessages]: (state, data) => {
        state.systemMessages = data;
    },
};

const notificationActions = {
        [storeAction.saveFCMToken]: ({ commit, state }, fcmData) => {
        return axios({
            url: `${state.baseURL}notifications/api/appnotification/insertpersonfcmtoken`,
            headers: getBasicHeaders(),
            data: fcmData,
            method: 'POST',
        })
            .then((response) => {
                console.log(response.data);
                commit(storeMutation.setfcmToken, fcmData.FcmToken);
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.updateNotificationsToIsRead]: ({ state }, personId) => {
        return axios({
            url: `${state.baseURL}notifications/api/appnotification/updatenotificationstoisviewed`,
            headers: getBasicHeaders(),
            data: `${personId}`,
            method: 'POST',
        })
            .then((response) => {
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getUnReadNotificationCount]: ({ commit, state }, personId) => {
        return axios({
            url: `${state.baseURL}notifications/api/appnotification/get-unviewed-notification-count/${personId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setUnReadNotificationCount, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.deletePersonFcmToken]: ({ commit, state }, fcmData) => {
        return axios({
            url: `${state.baseURL}notifications/api/appnotification/deletepersonfcmtoken`,
            headers: getBasicHeaders(),
            data: fcmData,
            method: 'POST',
        })
            .then((response) => {
                console.log(response.data);
                commit(storeMutation.setfcmToken, fcmData.Fcmtoken);
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    [storeAction.getnotifications]: wrapAction(storeAction.getnotifications, ({ state }, personId) => {
        return axios({
            url: `${state.baseURL}notifications/api/appnotification/get-notifications/${personId}`,
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    return response;
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
    }),
    [storeAction.getSystemMessages]: ({ commit, state }) => {
        return axios({
            url: `${state.baseURL}notifications/api/appnotification/get-system-messages`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setSystemMessages, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                return err;
            });
    },
};
const notificationGetters = {
    [storeGetters.fcmToken]: state => state.fcmToken,
    [storeGetters.systemMessages]: state => state.systemMessages,
};
export default {
    namespaced: true,
    state: {
        initialState: notificationState(),
        ...notificationState(),
    },
    mutations: { ...notificationMutations },
    actions: { ...notificationActions },
    getters: { ...notificationGetters },
};
